import { z } from 'zod';

const aim = z.enum(['helm', 'chest', 'shield']);

/** Moves the jousting engine accepts. Must match game-core's `JoustingMove`. */
export const joustingMoveSchemas = [
  z.object({ type: z.literal('charge'), aim, guard: z.enum(['high', 'low']), tick: z.number().int().min(0).max(60 * 30) }),
] as const;

const aimInfo = z.object({ label: z.string(), points: z.number().int(), window: z.number() });

export const joustingViewSchema = z.object({
  pass: z.number().int(),
  passes: z.number().int(),
  me: z.number().int(),
  foe: z.number().int(),
  foeName: z.string(),
  tells: z.string(),
  aims: z.object({ helm: aimInfo, chest: aimInfo, shield: aimInfo }),
  zone: z.number(),
  duration: z.number(),
  /** The chance a perfect strike to an open helm unhorses him. */
  unhorse: z.number(),
  last: z.object({ text: z.string(), mine: z.number().int(), his: z.number().int(), timing: z.number() }).nullable(),
  unhorsed: z.enum(['me', 'foe']).nullable(),
  over: z.boolean(),
});
export type JoustingView = z.infer<typeof joustingViewSchema>;
